import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgLipBalmGlyph from './svgs/LipBalmGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var lipBalmGlyph = (props => useIcon(SvgLipBalmGlyph, SvgLipBalmGlyph, props));

export { lipBalmGlyph as default };
